import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const CondolenceMenu = () => {
  const navigate = useNavigate();
  const [department, setDepartment] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    fetch('/api/condolence/check', { credentials: 'include' })
      .then(res => {
        if (!res.ok) { navigate('/condolence'); return null; }
        return res.json();
      })
      .then(data => {
        if (data) {
          if (data.must_change) {
            navigate('/condolence/change-password');
            return;
          }
          setDepartment(data.user.department);
          setIsAdmin(data.user.is_admin || false);
        }
      })
      .catch(() => navigate('/condolence'));
  }, [navigate]);

  const handleLogout = async () => {
    await fetch('/api/condolence/logout', { method: 'POST', credentials: 'include' });
    navigate('/condolence');
  };

  const cards = [
    {
      id: 'invite',
      title: '弔意URL発行',
      icon: '✉️',
      description: '従業員へ入力フォームのURLをメールで送信します（連絡を受けた人が発行）',
      path: '/condolence/invite',
    },
    {
      id: 'history',
      title: '提出済みデータ確認',
      icon: '📋',
      description: '訃報発信・弔電依頼・供花手配をします。',
      path: '/condolence/history',
    },
    ...(isAdmin ? [{
      id: 'history-all',
      title: '全店舗 提出情報一覧',
      icon: '🗂️',
      description: '全店舗の従業員から提出された慶弔情報を横断で確認します',
      path: '/condolence/history-all',
    }, {
      id: 'admin',
      title: '発注履歴管理',
      icon: '📊',
      description: '全店舗の供花発注履歴を確認します',
      path: '/condolence/admin',
    }, {
      id: 'password-admin',
      title: 'アカウント管理',
      icon: '🔐',
      description: '全アカウントのパスワードリセットができます',
      path: '/condolence/password-admin',
    }, {
      id: 'obituary-recipients',
      title: '店舗別 自店役職者(D)',
      icon: '✉️',
      description: '訃報送信先のうち各店舗の役職者アドレスを編集します',
      path: '/condolence/obituary-recipients',
    }, {
      id: 'mail-groups',
      title: 'メールグループ設定(A/B/C)',
      icon: '📮',
      description: '訃報送信先の全社共通グループ（本社・全店役職・管理部門）を編集します',
      path: '/condolence/mail-groups',
    }, {
      id: 'employee-master',
      title: '従業員マスタ取込',
      icon: '👥',
      description: '奉行から出力した従業員CSVを取り込みます（弔意URL発行に使用）',
      path: '/condolence/employee-master',
    }] : []),
  ];

  return (
    <div className="portal">
      <header className="portal-header" style={{ background: '#37474f' }}>
        <h1>慶弔ポータル</h1>
        <div className="header-right">
          <span className="store-name">{department}</span>
          <button
            className="logout-button"
            onClick={() => navigate('/condolence/change-password')}
            style={{ marginRight: '8px' }}
          >
            パスワード変更
          </button>
          <button className="logout-button" onClick={handleLogout}>
            ログアウト
          </button>
        </div>
      </header>

      <main className="portal-main">
        <div className="section-bar" style={{ background: '#eceff1' }}>
          <span className="icon">🕯️</span>
          <span className="title" style={{ color: '#37474f' }}>メニューを選択してください</span>
        </div>

        <div className="cards-grid">
          {cards.map((card) => (
            <div
              key={card.id}
              className="card"
              onClick={() => card.externalUrl ? window.open(card.externalUrl, '_blank') : navigate(card.path)}
            >
              <div className="card-icon" style={{ background: '#eceff1' }}>{card.icon}</div>
              <h3>{card.title}</h3>
              <p>{card.description}</p>
              <button style={{ background: '#37474f' }}>
                選択 &gt;
              </button>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
};

export default CondolenceMenu;
